import React from "react";
import Locandina from "../imgs/LocandinaScuola.jpg";

const MilarteFaScuola = () => {
  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl ">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        MILARTE FA SCUOLA
      </p>
      <div className="flex flex-col justify-center text-center w-2/3">
        <div>
          MilArte propone la nascita di una scuola di musica, con l’intento di
          diffondere la Bellezza del far musica, alla scoperta di un valore
          aggiunto alla persona. Chiunque può avvicinarsi a questa esperienza, a
          qualsiasi età! Non ultimo MilArte desidera coinvolgere giovani che
          possano dare un contributo significativo alle attività pastorali,
          attraverso l’insegnamento del canto, della chitarra e del pianoforte:
          saranno loro poi gli artefici dei canti della S. Messa.
        </div>
        <div className="flex flex-col items-center mt-5">
          <p>Inizio lezioni dal mese di ottobre 2024 dei seguenti strumenti:</p>
          <div className="flex flex-col items-start">
            <p>• Pianoforte</p>
            <p>• Chitarra</p>
            <p>• Violino</p>
            <p>• Flauto</p>
            <p>• Chitarra </p>
            <p>d'accompagnamento</p>
            <p>• Tastiera</p>
            <p>• Organo</p>
            <p>• Clarinetto</p>
            <p>• Tromba</p>
            <p>• Violoncello</p>
            <p>• Coro voci bianche</p>
          </div>
          <p className="mt-6">
            Le lezioni saranno settimanali di 45 minuti presso i locali
            dell’oratorio di S Luigi. Per informazioni scrivere a :
            <div>
              <a
                href="mailto:info@milarte.it"
                className="underline text-red-600"
              >
                {" "}
                milarte.mi@gmail.com
              </a>
              {"-"}
              <a
                href="mailto:milarte.mi@pec.it"
                className="underline text-red-600"
              >
                milarte.mi@pec.it
              </a>
            </div>
            <p>
              Giuseppe Dinardo:
              <p>+39 338 830 3778</p>
            </p>
          </p>
          <div>
            <p>
              Per iscriversi bisogna compilare il seguente modulo a questo{" "}
              <a
                href="https://form.jotform.com/242094826225356"
                className="text-red-600 underline"
              >
                link
              </a>
            </p>
          </div>
          <img src={Locandina} className="w-4/5" />
        </div>
      </div>
    </div>
  );
};

export default MilarteFaScuola;
